export const getLabelSegmentTypeList = (
  segmentId: string,
  segments: Array<{ value: string; label: string }>
): string | undefined => {
  return segments.find((segment) => segment.value === segmentId)?.label;
};
